import { ENTITY_NAME_IN_URI as ENTITY_NAME_IN_URI_V2 } from "@/api/config/api2.0";
import { get as getV2, post as postV2 } from "@/api/getApi2.0";

export const getItemsLineFromSponsoring = (campaignId, filters, axios) =>
  getV2(
    {
      path: ENTITY_NAME_IN_URI_V2.CAMPAIGNS.ORDERS_LINES.path,
      ressources: [
        {
          name: campaignId,
          value: ENTITY_NAME_IN_URI_V2.CAMPAIGNS.ORDERS_LINES.name
        }
      ]
    },
    filters,
    axios
  );

export const getItemsLineStats = (campaignId, filters, axios) =>
  postV2(
    {
      path: ENTITY_NAME_IN_URI_V2.STATS_ORDERS_LINES_SUMMARY.path,
      ressources: [
        {
          name: campaignId
        },
        {
          name: ENTITY_NAME_IN_URI_V2.STATS_ORDERS_LINES_SUMMARY.name,
          value: ENTITY_NAME_IN_URI_V2.STATS_ORDERS_LINES_SUMMARY.value
        }
      ]
    },
    {},
    filters,
    axios
  );
